module.exports = __webpack_public_path__ + "img/earn_payment.de7c8be2.svg";